<template>
  <div class="centix-timeinput">
    <span class="holder-span">
          <input
            class="search-input"
            ref="inputItem"
            type="text"
            v-model="filtered"
            v-on:keyup.enter="onReturn($event)"
            v-on:input="onInput($event)"
            v-on:blur="onBlur($event)"
            v-bind:disabled="disabled">
        </span>
  </div>
</template>

<script>
import moment from 'moment/src/moment';

export default {
  name: 'TimeInput',
  props: {
    value: {
      default: null
    }
  },
  model: {
    prop: 'value',
    event: 'value-changed'
  },
  data() {
    return {
      filtered: '',
      disabled: false
    };
  },
  mounted() {
    this.datetime = moment(this.value);
  },
  watch: {
    value() {
      this.datetime = moment(this.value);
      this.updateLocal();
    }
  },
  computed: {
    hasValue() {
      return true;
    },
    showRequiredClass: function () {
      if (this.required && !this.hasValue) {
        return true;
      } else {
        return false;
      }
    },
    localvalue: {
      get() {
        return this.datetime;
      },
      set(newvalue) {
        this.datetime = newvalue;
        this.$emit('value-changed', newvalue);
      }
    }
  },
  methods: {
    updateLocal() {
      this.filtered = moment(this.datetime).format('HH:mm');
    },
    onReturn(event, column) {

    },
    onInput(event) {
      let values = this.filtered.split(':');
      let minutes = values[1] ? values[1] : 0;
      this.$log('minutes', minutes, 'hours', values[0]);

      this.datetime = moment(this.datetime);
      this.datetime.hours(values[0]);
      this.datetime.minutes(minutes);
    },
    onBlur(event) {
      this.localvalue = this.datetime.toDate(); 
      this.updateLocal();
    }
  }
};
</script>

<style lang="scss">
.holder-span {
  position: relative;
  display: block;

  input {
    width: 100%;
  }
}
</style>
